import { BaseFieldEmits } from 'SharedComponents/Fields/composables/useBaseFieldProps';
import { FieldHistory, FieldValue } from 'SharedDir/declarations/fields';
import { DefinedEmits, DefinedProps } from 'SharedDir/declarations/vue';
import { computed } from 'vue';

export interface ViewFieldProps<T> {
  modelValue: FieldValue<T>;
  label: string;
  showHistory?: boolean;
  history?: FieldHistory[];
}

export default <T>(
  props: DefinedProps<ViewFieldProps<T>>,
  emit: DefinedEmits<BaseFieldEmits>,
  defaultFactory: () => any = () => ''
) => {
  const value = computed(() => props.modelValue?.value ?? defaultFactory());
  return { value };
};
